import styled from 'styled-components'

export const Legenda = styled.small`
  font-size: 13px;
  color: var(--Gray3);
  font-weight: 499;
  margin-top: .5rem;
`
